














































import Vue from 'vue';
import CustomerTable from './CustomerTable.vue';
import CustomerDisplaySettings from './CustomerDisplaySettings.vue';
import customerVuex from '../../vuex/common';
import SidePage from 'common/components/ui/SidePage/index.vue';

export default Vue.extend({
  mixins: [customerVuex],
  props: {
    fixed: Boolean,
    canScrollY: {
      type: Boolean,
      default: true,
    },
    onSearch: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CustomerTable,
    CustomerDisplaySettings,
    SidePage,
  },
  data() {
    return {
      loading: false,
      contentHeight: 'auto',
      firstLoad: true,
      showEmpty: false,
      syncImg: require('assets/img/sync.svg'),
    };
  },
  computed: {
    customerTotal(): number {
      return this.customerState.customerList.total;
    },
  },
  methods: {
    showCustomerExport() {
      if (this.accountState.crmLevel) {
        this.$store.commit('SHOW_CUSTOMER_EXPORT');
      } else {
        this.$Message.warning('权限不足，试用期会员不支持粉丝导出');
      }
    },
    showCustomerAnalyze() {
      this.$store.commit('SHOW_CUSTOMER_ANALYZE');
    },
    setContentHeight() {
      const height = window.document.body.offsetHeight - 112;
      this.contentHeight = `${height}px`;
    },
    customerLoaded() {
      if (this.firstLoad) {
        // this.showEmpty = this.customerState.customerList.total < 1;
        this.firstLoad = false;
      }
      this.showEmpty = this.duringFirstSync;
      this.$emit('loaded');
    },
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.setContentHeight();
    });
    this.$nextTick(() => {
      this.setContentHeight();
    });
  },
});
